export default __webpack_public_path__ + "static/media/buyerprotection.0c8edf22.svg";